export default __webpack_public_path__ + "static/media/4.8809b381.png";